import StakingView from "./StakingView";
export default StakingView;